import { useParams } from 'next/navigation';
import { useLayoutEffect } from 'react';

import { useCurrentBot } from '~hooks/useCurrentBot';
import { usePathname } from '~i18n/navigation';

export const useBotColors = () => {
	const pathname = usePathname();
	const { recipientId = '' } = useParams<{ recipientId?: string }>();
	const { bot } = useCurrentBot({ recipientId });

	useLayoutEffect(() => {
		if (bot && pathname !== '/') {
			if (!bot.colors?.main) {
				document.documentElement.style.removeProperty('--bot-color-main');
			} else {
				document.documentElement.style.setProperty(
					'--bot-color-main',
					bot.colors?.main
				);
			}
		}
	}, [bot, bot.colors?.main, pathname]);
};
